import { APICore } from './apiCore';
const api = new APICore();

// category
function cartList(params) {
    const baseUrl = `/cart`;
    return api.get(`${baseUrl}`, params);
}

function addCart(params) {
    const baseUrl = `/cart`;
    return api.create(`${baseUrl}`, params);

}
function updateCart(params, id) {
    const baseUrl = `/cart/${id}`;
    return api.updatePatch(`${baseUrl}`, params);
}
function deleteCart(id) {
    const baseUrl = `/cart/${id}`;
    return api.delete(`${baseUrl}`);

}



export {
    cartList, addCart, updateCart, deleteCart
};
